<template>
  <div class="index">
    <nav-header></nav-header>

    <div class="my-container">

      <!-- banner 区块 -->
      <div class="banner">
        <img src="/imgs/banner.jpg" alt="">
      </div>

      <!-- 资讯区块 -->
      <div class="ac-con">
        <!-- 左侧 -->
        <div class="main-left">
          <div class="art-list cl">

            <!-- 循环项 -->
            <article class="d-flex flex-wrap" v-for="(item, index) in this.d2" :key="index"
              @click="goDays(item.methods, item.id)">
              <div class="box">
                <h2><a href="javascript:;">{{ item.title }}</a></h2>

                <p>{{ item.article1 }}</p>

                <div class="info"> <span class="s"><a class="category brightness transition br"
                      href="javascript:;">立即阅读</a> </span> <span class="s">{{ item.time }}</span> </div>
              </div>
              <div class="img" style="flex-basis: 18%;border-radius:10px;">

                <img :src="item.img">

              </div>
            </article>

          </div>
        </div>
        <!-- 右侧 -->
        <div class="mainr" style="position: relative; overflow: visible; box-sizing: border-box; ">

          <div class="theiaStickySidebar">
            <div class="clear"></div>
            <div class="widgets">
              <h4 class="bar">热门资讯</h4>
              <div class="hot-post">
                <ul>

                  <!-- 循环项 -->
                  <li class="cl" v-for="(item, index) in this.d1" :key="index" @click="goDays(item.methods, item.id)">
                    <a href="javascript:;" :title="item.title">
                      <span class="img-box mb5">
                        <img :src="item.img">
                      </span>
                      <b class="sptit">{{ item.title }}</b>
                    </a>
                    <span class="op"><i class="iconfont icon-shijian" style="margin-right: 5px;"></i>{{ item.time
                    }}</span>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <nav-footer></nav-footer>
    <modal title="请选择支付方式" btnType="1" modalType="middle" :showModal="showModal" @submit="showModal = false"
      @cancel="showModal = false">
      <template v-slot:body>
        <img style="display: flex; justify-content: center; margin: 0 auto" src="/imgs/pay2.png" />
        <h2>微信支付：2元/篇</h2>
      </template>
    </modal>
  </div>
</template>

<script>

import NavFooter from "./../components/NavFooter";
import NavHeader from "./../components/NavHeader";
import Modal from "./../components/Modal";

export default {
  name: "index",
  components: {
    NavFooter,
    NavHeader,
    Modal,

  },
  data() {
    return {
      d1: [],
      d2: [],
      d3: [],
      d4: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.init();
    document.title = "北京质子游戏科技有限公司";
  },
  methods: {
    init() {
      this.axios.get("/mock/article1.json").then((res) => {
        const data = res.data;
        this.d2 = data.slice(0, 6);
        this.d1 = data.slice(6, 16);
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound:" + id,
        query: { type: id },
      });
    },
    // 收费逻辑
    gopay() {
      alert('请扫码付费后阅读~');
      this.showModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.index {
  background: #e4eaf6;
  box-sizing: border-box;

  .my-container {
    padding-top: 5px;
    box-sizing: border-box;
    position: relative;
    width: 1200px;
    margin-right: auto;
    margin-left: auto;

    .banner {
      width: 100%;
      box-shadow: 0 10px 15px rgba(0, 0, 0, 0.04);
      height: 320px;
      margin: 35px 0;

      img {
        width: 100%;
        height: 100%;
        border-radius: 20px;
        object-fit: cover;
      }
    }

    .swiper-box {
      width: 100%;
      box-shadow: 0 10px 15px rgba(0, 0, 0, 0.04);
      // height: 320px;
      margin: 35px 0;
      border-radius: 20px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 20px;
        object-fit: cover;
      }
    }

    .ac-con {
      width: 1280px;
      margin: 0 auto;
      height: 1700px;

      .main-left {
        float: left;
        width: 920px;

        article {
          background: #fff;
          transition: all .2s ease;
          overflow: hidden;
          width: 100%;
          margin-right: 20px;
          margin-bottom: 20px;
          overflow: hidden;
          transform: translateY(2px);
          box-shadow: 0 10px 15px rgba(0, 0, 0, 0.04);
          transition-property: transform, box-shadow;
          transition: .25s cubic-bezier(.215, .61, .355, 1);
          min-height: 250px;
          background: linear-gradient(180deg, hsla(0, 0%, 100%, .36), hsla(0, 0%, 100%, .2));
          background-size: auto;
          background-size: 100% 100%;
          border-radius: 20px;
          border: 1px solid rgba(255, 255, 255, .6);
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;

          &:hover {
            transform: translateY(0);
            box-shadow: 0 20px 80px rgba(0, 0, 0, .1), 0 5px 20px rgba(0, 0, 0, .05);
            transition: all .2s ease;
            background: url('/imgs/bg.png') no-repeat 0 0;
            background-size: 100% 100%;
          }

          .box {
            padding: 30px;
            width: calc(100% - 35%);
            padding-bottom: 20px;

            h2 {
              a {
                color: #333;
                text-decoration: none;
                outline: 0;
                font-size: 20px;
                line-height: 28px;

                &:hover {
                  @keyframes waveMove {
                    0% {
                      background-position: 0 100%;
                    }

                    100% {
                      background-position: -20px 100%;
                    }
                  }

                  text-decoration: none;
                  background: url('/imgs/a.svg') repeat-x 0 100%;
                  background-size: 20px auto;
                  animation: waveMove 1s infinite linear;
                  padding-bottom: 4px;
                }
              }


            }

            p {
              font-size: 16px;
              margin-top: 20px;
              color: #000;
              opacity: .6;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .info {
              margin: 20px 0;
              border-top: 1px solid #e4edef;
              padding-top: 15px;
              margin-bottom: 0;
              display: flex;

              span {
                opacity: .6;
                padding-right: 30px;
              }

              .s {
                position: relative;
                align-items: center;
                display: flex;

                &:nth-child(1) {
                  opacity: 1;
                  padding-right: 10px;
                  flex: 1;
                  cursor: pointer;

                  a {
                    color: #00BDD7;
                    padding: 5px 20px;
                    border-radius: 100px;
                    text-align: center;
                    display: inline-block;
                    font-size: 13px;
                    border: 1px solid #00BDD7;
                    box-shadow: 0 10px 15px rgba(21, 150, 164, 0);
                    overflow: hidden;
                    height: 20px;
                    line-height: 20px;


                    &:hover {

                      background: #00BDD7;
                      color: #fff;
                      border: 1px solid #00BDD7;
                      box-shadow: 0 10px 15px rgba(21, 150, 164, 0.15)
                    }
                  }
                }
              }
            }
          }

          .img {
            margin: auto;
            width: 200px;
            height: 200px;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: all .3s;
              border-radius: 20px;

              &:hover {
                transform: scale(1.1) rotate(1deg);
              }
            }

            .img-box {
              display: block;
              position: relative;
              width: 100%;



            }
          }

        }
      }

      .mainr {
        float: right;
        width: 340px;

        .widgets {
          padding: 30px;
          background: #fff;
          box-shadow: 0 10px 15px rgba(0, 0, 0, 0.04);
          transition: all .2s ease;
          margin-bottom: 20px;
          background: linear-gradient(180deg, hsla(0, 0%, 100%, .36), hsla(0, 0%, 100%, .2));
          background-size: auto;
          background-size: auto;
          background-size: 100% 100%;
          border-radius: 20px;
          border: 1px solid rgba(255, 255, 255, .6);
          overflow: hidden;

          .bar {
            width: 100%;
            height: 36px !important;
            line-height: 36px !important;
            margin-top: -10px;
            border: none !important;
            font-size: 20px;
            font-weight: 600;
            position: relative;
            padding-left: 0px;
            margin-bottom: 10px;
          }

          .hot-post {
            float: left;
            width: 100%;

            ul {
              margin-right: -30px;

              li {
                width: calc(100% - 30px);
                list-style: none;
                margin: 25px 0 50px;

                a {
                  width: 100%;
                  color: #333;
                  text-decoration: none;
                  outline: 0;
                  display: block;
                  padding: 0px;

                  &:hover {
                    color: #00BDD7;
                    text-decoration: none;
                  }

                  .img-box {
                    overflow: hidden;
                    display: block;
                    position: relative;
                    width: 100px;
                    height: 100px;
                    float: right;
                    border-radius: 10px;

                    &:hover {
                      img {
                        transform: scale(1.1) rotate(1deg);
                        transition: all .3s;
                      }
                    }
                  }

                  b {
                    line-height: 22px;
                    font-weight: normal;
                    margin-bottom: 15px;
                    padding-top: 10px;
                    height: 44px;
                    overflow: hidden;
                    float: left;
                    width: calc(100% - 120px);
                    font-size: 16px;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                  }
                }

                .op {
                  opacity: .5;
                  padding-top: 10px;
                }
              }
            }
          }
        }
      }
    }
  }

}
</style>